import React, { type FunctionComponent, type ReactNode } from 'react'
import { type TestableProps } from 'legacy/common/utils/testing/testing.types'
import { Flex } from 'legacy/dash-blocks/flex/Flex'
import { type OverridableStyles } from 'legacy/common/utils/styling/styling.types'

interface Props extends TestableProps, OverridableStyles {
  leftComponents?: ReadonlyArray<ReactNode>
  rightComponents?: ReadonlyArray<ReactNode>
}

export const DashContentBar: FunctionComponent<Props> = ({
  leftComponents,
  rightComponents,
  overrideStyle,
}) => (
  <Flex
    justify="space-between"
    wrap="nowrap"
    fillWidth
    margin={['none', 'small']}
    overrideStyle={overrideStyle}
  >
    <Flex wrap="nowrap" overrideChildStyles={{ marginRight: 'xsmall' }}>
      {leftComponents}
    </Flex>

    <Flex
      justify="flex-end"
      align="center"
      wrap="nowrap"
      overrideChildStyles={{ marginLeft: 'xsmall' }}
    >
      {rightComponents}
    </Flex>
  </Flex>
)
